import gql from 'graphql-tag'

export const GET_BANK_TRANSACTIONS = gql`
    query fetchBankTransactions($input: ListTransactionsInput) {
        listBankTransactions(input: $input) {
            items {
                accountId
                id
                description
                date
                impact
                itemId
                type
                amount {
                    currency
                    value
                }
            }
            nextToken
        }
    }
`

export const GET_CRYPTO_TRANSACTIONS = gql`
    query fetchCryptoTransactions($input: ListTransactionsInput) {
        listCryptoTransactions(input: $input) {
            items {
                amount {
                    currency
                    value
                }
                category
                date
                fiat {
                    currency
                    value
                }
                impact
                name
                transactionType
            }
            nextToken
        }
    }
`
